module.exports = __webpack_public_path__ + "img/demo4-about-pro-ja.ab552b83.png";